import type { ProjectListItem } from '@/types/project.types';
import type { RuleSetListItem } from '@/types/ruleSet.types';

export interface ProjectRuleSetInfo {
  /** Title of the set the project is machined with, or its bare name when the backend no longer lists it. */
  label: string;
  /** Version the project was processed with; `null` before processing. */
  version: number | null;
  /** Current version of the same set as the backend lists it; `null` when it is not listed. */
  currentVersion: number | null;
  /** The set was revised after this project was processed with it. */
  changed: boolean;
}

/**
 * What to show for the rule set a project is machined with.
 *
 * A project with no set of its own follows the one marked default; `null` means nothing is
 * known yet (the list of rule sets has not loaded and the project names none).
 */
export function projectRuleSetInfo(
  project: Pick<ProjectListItem, 'hole_rule_set' | 'hole_rule_set_version'>,
  ruleSets: RuleSetListItem[]
): ProjectRuleSetInfo | null {
  const name = project.hole_rule_set ?? ruleSets.find((ruleSet) => ruleSet.is_default)?.name ?? null;
  if (name === null) return null;
  const known = ruleSets.find((ruleSet) => ruleSet.name === name);
  const version = project.hole_rule_set_version ?? null;
  const currentVersion = known?.version ?? null;
  return {
    label: known ? known.title || known.name : name,
    version,
    currentVersion,
    changed: version !== null && currentVersion !== null && currentVersion !== version,
  };
}
